import { render, staticRenderFns } from "./PolizasEmitidas.vue?vue&type=template&id=21bf4eb8"
import script from "./PolizasEmitidas.vue?vue&type=script&lang=js"
export * from "./PolizasEmitidas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports